import React from "react";

function ScanOutputField({ value }) {

    return (
        <div className="oct-shared-popup__field">
            <label className="oct-shared-popup__label" htmlFor="scan-output">Scan Output</label>
            <textarea
                className="oct-shared-popup__textarea oct-shared-popup__textarea--code"
                id="scan-output"
                value={value}
                rows={16}
                disabled={true}
                readOnly
            />
        </div>
    )

}

export default ScanOutputField;
